import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Dialog, Loading, OverlayTrigger, PopOver, Switch } from '@tencent/spaui';
import { RPCFactory } from '../../../../utils/RequestUtil';
import { renderRangeDetail } from '../../../helper/RuleApplyRangeHelper';

import useDialog from '../../../../leads_component/shared-components/hooks/useDialog';
import useList from '../../../../leads_component/shared-components/hooks/useList';

import { OPERATION } from './config';
import { isMainAccount, isSubAccount } from '../../../../consts/multiAccountConfig';
import EditRule from './rule';

const Page = (props) => {
  const [industryList, setIndustryList] = useState([]);
  const [talkList, setTalkList] = useState([]);
  const [ruleList, setRuleList] = useState([]);
  const currentRuleHooks = useList({ data: [] });

  const ruleDialog = useDialog({ showDialog: false });
  const [isEdit, setIsEdit] = useState(false);
  const [dragItem, setDragItem] = React.useState(-1);
  const [reload, setReload] = React.useState(0);
  const [isLoading, setLoading] = React.useState(false);

  const getDescription = () => {
    if (isMainAccount()) {
      return '线索清洗将按以下规则的先后顺序分配，点击编辑后可拖拽调换线索顺序, 保存后生效。已设定的线索清洗规则将在此账号绑定的子账号中同时生效。';
    }
    if (isSubAccount()) {
      return '子账号不允许进行线索清洗设置，请在对应主账号中进行线索清洗规则设置。';
    }
    return '线索清洗将按以下规则的先后顺序分配，点击编辑后可拖拽调换线索顺序, 保存后生效。';
  };

  const getIndustry = (id) => {
    const res = industryList.find((ele) => ele.industryCategoryId == id);

    return res ? res : {};
  };

  const getTalk = (industyId, callTalkId) => {
    const res = talkList.find((ele) => ele.industryCategoryId == industyId && ele.callTalkId == callTalkId);

    return res ? res : {};
  };
  useEffect(() => {
    RPCFactory.leadsCleaning
      .getIndustryList()
      .done((data) => {
        setIndustryList(data);
      })
      .fail((status, msg) => {
        alert(msg);
      });

    RPCFactory.leadsCleaning
      .getTalkList()
      .done((data) => {
        setTalkList(data);
      })
      .fail((status, msg) => {
        alert(msg);
      });

    setLoading(true);

    RPCFactory.leadsCleaning
      .getRuleList()
      .done((data) => {
        setLoading(false);
        setRuleList(data.entities);
      })
      .fail((status, msg) => {
        setLoading(false);
        alert(msg);
      });

    // setIndustryList(mockIndustryList);
    // setTalkList(mockTalkList);
    // setRuleList(mockRuleList);
  }, []);

  useEffect(() => {
    setLoading(true);
    RPCFactory.leadsCleaning
      .getRuleList()
      .done((data) => {
        setLoading(false);
        setRuleList(data.entities);
      })
      .fail((status, msg) => {
        setLoading(false);
        alert(msg);
      });
  }, [reload]);

  const renderIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
      <g fill="#313233" fillRule="nonzero">
        <path d="M12.126 10.543h.006v-.037l-.006.037zM10.082 1.17a.442.442 0 00-.24-.087c-.222 0-.402.192-.402.427 0 .17.095.307.23.384 1.474.914 2.465 2.61 2.465 4.554 0 1.942-.99 3.638-2.463 4.551a.462.462 0 00-.24.39c0 .236.18.428.401.428.09 0 .16-.037.237-.084 1.711-1.061 2.862-3.03 2.862-5.285 0-2.251-1.146-4.216-2.85-5.278z" />
        <path d="M10.548 6.448c0-1.323-.675-2.477-1.68-3.098a.58.58 0 00-.227-.075c-.223 0-.403.192-.403.429 0 .159.079.3.2.375.776.468 1.3 1.353 1.3 2.369 0 1.033-.542 1.932-1.34 2.394a.435.435 0 00-.194.367c0 .237.18.43.403.43a.537.537 0 00.208-.06c1.033-.612 1.733-1.784 1.733-3.131zM6.474.017L3.246 3.24v.005H.006V9.7h3.223l3.245 3.225h1.078V.017H6.474zM3.229 8.625H1.094V4.318h2.152v.005l3.228-3.232v10.757L3.229 8.625z" />
      </g>
    </svg>
  );

  const renderVariables = (map = [], list) => {
    if (!_.isArray(list)) {
      return;
    }
    return list.map((ele) => {
      const { name = '', value = '' } = ele;
      const obj = map.find((e) => {
        if (e && e.name) {
          return e.name == name;
        }
        return false;
      });

      if (!obj || !obj.cname) {
        return null;
      }

      return <span>{`${obj.cname}:${value}`}</span>;
    });
  };
  const handleAdd = () => {
    ruleDialog.showAsAddModel();
  };

  const handleEdit = () => {
    const copy = _.cloneDeep(ruleList);
    currentRuleHooks.setDataList(copy);
    setIsEdit(true);
  };

  const handleDrop = (e, index, isLast) => {
    if (!isEdit || isLast) {
      return;
    }
    // currentRuleHooks.onItemSwitch(dragItem, index);

    const _dataList = _.cloneDeep(currentRuleHooks.dataList);

    _dataList[index] = currentRuleHooks.dataList[dragItem];
    _dataList[index].status = 2;

    _dataList[dragItem] = currentRuleHooks.dataList[index];
    _dataList[dragItem].status = 2;

    currentRuleHooks.setDataList(_dataList);
  };

  const handleSubmit = (params) => {
    if (ruleDialog.contentProps.model == 'edit') {
      const _list = _.cloneDeep(currentRuleHooks.dataList);
      const index = _list.findIndex((e) => e.id == params.id);

      if (index >= 0) {
        _list[index] = params;
        currentRuleHooks.setDataList(_list);
        ruleDialog.props.onCancel();
      }
    } else {
      RPCFactory.leadsCleaning
        .updateRuleList({
          callCleaningRules: [params],
        })
        .done(() => {
          ruleDialog.props.onCancel();
          setReload(reload + 1);
        })
        .fail((status, msg) => {
          alert(msg);
        });
    }
  };

  const handleClick = (sampleAudioUrl) => {
    // window.open(sampleAudioUrl, '_blank');
    new Audio(sampleAudioUrl).play();
  };

  const handleSave = () => {
    RPCFactory.leadsCleaning
      .updateRuleList({
        callCleaningRules: currentRuleHooks.dataList,
      })
      .done(() => {
        setReload(reload + 1);
        setIsEdit(false);
      })
      .fail((status, msg) => {
        alert(msg);
      });
  };

  const renderAction = (index, ele, isLast) => {
    const e = ele || {};
    const { enabled = false } = e;

    ele.isLast = isLast;

    return (
      <div className="action">
        <Switch
          checked={enabled}
          onChange={(event, checked) => {
            if (!ele.callTalkId) {
              alert('请先对规则进行设置');
              return;
            }
            currentRuleHooks.onItemChangeBatch(index, {
              enabled: checked,
              status: OPERATION.EDIT,
            });
          }}
        />
        <a
          aria-label="编辑"
          className="editable-icon"
          onClick={() => {
            ruleDialog.showAsEditModel(ele);
          }}
        >
          <i className="icon icon-pen"></i>
        </a>
        {isLast ? null : (
          <a
            aria-label="删除"
            className="editable-icon"
            onClick={() => {
              currentRuleHooks.onItemChange(index, 'status', OPERATION.DELETE);
            }}
          >
            <i className="icon icon-close"></i>
          </a>
        )}
      </div>
    );
  };

  const renderStaticAction = (index, ele) => {
    const e = ele || {};
    const { enabled = false } = e;

    return (
      <div className="action">
        <OverlayTrigger trigger="click" overlay={<PopOver>点击编辑后进行修改</PopOver>}>
          <Switch disabled checked={enabled} />
        </OverlayTrigger>
      </div>
    );
  };

  const renderRuleList = () => {
    const _ruleList = isEdit ? currentRuleHooks.dataList : ruleList;
    if (!_.isArray(_ruleList)) {
      return null;
    }
    let indexNumber = 1;

    const len = _ruleList.length;
    return (
      <ul className="custom-infolist">
        {_ruleList.map((ele, index) => {
          const isLast = ele.applyRange.applyRangeType === 'ELSE';
          if (!ele || ele.status == OPERATION.DELETE) {
            return null;
          }

          const { industryCategoryName = '' } = getIndustry(ele.industryCategoryId);

          const { callTalkName, sampleAudioUrl, variables: variableMap } = getTalk(
            ele.industryCategoryId,
            ele.callTalkId,
          );

          return (
            <li
              className={isEdit && !isLast ? 'item dragged' : 'item'}
              draggable={isEdit && !isLast ? 'true' : 'false'}
              onDragStart={() => {
                setDragItem(index);
              }}
              onDrop={(event) => handleDrop(event, index, isLast)}
              onDragOver={(e) => {
                e.preventDefault();
              }}
            >
              <span className="item-left">{indexNumber++}</span>
              <div className="item-right">
                <div className="content">
                  <p className="tt">
                    {ele.name}
                    <a
                      className="audio"
                      onClick={() => {
                        handleClick(sampleAudioUrl);
                      }}
                    >
                      {renderIcon()}
                      <span className="name">
                        {industryCategoryName && callTalkName ? `${industryCategoryName}-${callTalkName}` : '待配置'}
                      </span>
                    </a>
                  </p>
                  <p className="desc">
                    {isLast ? null : <span>{`适用范围：${renderRangeDetail(ele.applyRange)}`}</span>}
                    {renderVariables(variableMap, ele.variables)}
                  </p>
                </div>
                {isEdit ? renderAction(index, ele, isLast) : renderStaticAction(index, ele)}
              </div>
            </li>
          );
        })}
      </ul>
    );
  };
  return (
    <div className="sec baserule-sec save">
      <div className="card">
        <div className="panel base-set">
          <div className="tt-wraper fe-flex-spacebetween">
            <em className="tt">
              <strong>线索清洗规则</strong>
            </em>
            {/* <div class="action-wraper">
                            { isEdit ? null : <a class="edit" onClick={handleEdit} >编辑</a> }
                        </div>*/}
          </div>
          <em className="tt desc">{getDescription()}</em>
          {!isSubAccount() && (
            <div className="rules">
              {/* <div id="clearrule_dialog">*/}
              {/*    */}
              {/* </div>*/}
              <div className="action-wraper">
                {isEdit ? null : (
                  <button className="spaui-button spaui-button-primary" type="button" onClick={handleAdd}>
                    ＋添加线索清洗规则
                  </button>
                )}
                {isEdit ? null : (
                  <button className="spaui-button spaui-button-primary" type="button" onClick={handleEdit}>
                    编辑规则
                  </button>
                )}
              </div>
              {isLoading ? <Loading /> : renderRuleList()}
            </div>
          )}
          {isEdit ? (
            <div className="action-wraper">
              <button
                className="spaui-button spaui-button-default"
                type="button"
                onClick={() => {
                  setIsEdit(false);
                }}
              >
                取消
              </button>
              <button className="spaui-button spaui-button-primary" type="button" onClick={handleSave}>
                保存
              </button>
            </div>
          ) : null}
        </div>
      </div>
      {ruleDialog.showDialog ? (
        <Dialog
          {...ruleDialog.props}
          title={ruleDialog.contentProps.model == 'edit' ? ruleDialog.contentProps.data.name : '添加线索清洗规则'}
          className="customrule-dialog modal-max-height"
          style={{ width: '700px' }}
          hideFooter
        >
          <EditRule
            {...ruleDialog.contentProps}
            industryList={industryList}
            talkList={talkList}
            onCancel={ruleDialog.props.onCancel}
            onSubmit={handleSubmit}
          ></EditRule>
        </Dialog>
      ) : null}
    </div>
  );
};

export default Page;
